import { gql } from '@apollo/client';
import { tenant, tenantType, tenantTypeFirstUpperCase } from '../../tenant';
import moment from "moment/moment.js";

const UPSERT_USER = gql`
mutation upsertUser ($input: UserMutationInput!) {
  clubmate {
     upsertUser(input:$input){
    	clientMutationId
      errors{
        messages
      }
    }
  }
}
`


const DELETE_USER = gql`
mutation deleteUserClubmate($id: ID!) {
  clubmate{
    deleteUser(id: $id) {
      message
      ok
    }
  }
}
`

const GET_USER = gql`
query GetUser($id:bigint!){
  ${tenant}_users_user${tenantType}_by_pk(id:$id){
    id
    fiscal_code
    name
    surname
    registration_number
    telephone_number
    cost_ext
    cost_int
    date_of_birth
    modify_registry
    show_in_calendar
    external_erp_code
    mailingList_mailinglistusers{
      id
      mailingList_mailinglist{
        id
        email
      }
    }
    users_userareas{
      id
      user_id
      area_id
    }
  }
}
`

const QUERY_MAX_REGISTRATION_NUMBER=gql`
query getMaxRegistrationNumber {
  ${tenant}{
    userGolfRegistrationNumber
  }
}
`;

const QUERY_USER_PACKAGE_LIST =gql`
query userPackage($userId: bigint!) {
  clubmate_clubmatepackage_clubmatepackage(where: {usersregister_userpackages: {usersregister_userregister: {id: {_eq: $userId}}}}) {
    id
    name
  }
}
`

const QUERY_PACKAGE_LIST=gql`
query packageList {
  clubmate_clubmatepackage_clubmatepackage {
    id
    name
  }
}
`

const QUERY_USER_PACKAGE=gql`
query userPackage($userId: bigint!) {
  clubmate_usersregister_userpackage(where: {user_id: {_eq: $userId}}, order_by: {expire_at: desc}) {
    id
    paid
    expire_at
    number_of_entry
    is_renewal
    date_of_subscription
    clubmatepackage_clubmatepackage {
      id
      name
    }
    usersregister_userregister{
      id
      name
    }
  }
}
`

const UPSERT_USER_PACKAGE=gql`
mutation upsertUserPackage($input:UserPackageMutationInput!){
  clubmate{
    upsertUserPackage(input: $input){
      userPackage{
        id
      }
    }
  }
}
`

const GET_WALLET=gql`
query wallet($id:bigint!){
  clubmate_clubmatewallet_clubmatewallet_by_pk(id:$id){
    id
    amount
    clubmatewallet_movementwallets(order_by:{datetime:desc}){
      id
      quantity
      datetime
      clubmateservice_clubmateservice{
        id
        name
      }  
    }
  }
}
`
const DELETE_USER_PACKAGE=gql`
mutation deleteUserPackage($id:ID!){
  clubmate{
    deleteUserPackage(id:$id){
      ok
      message
    }
  }
}
`

const QUERY_SINGLE_USER_PACKAGE=gql`
query userPackage($id:bigint!){
  clubmate_usersregister_userpackage_by_pk(id:$id){
    user_id
    package_id
  }
}
`

const QUERY_USER_ENTRANCE=gql`
query userEntrance($userId:bigint!){
  clubmate_entrance_entrance(where:{user_id:{_eq:$userId}},order_by:{datetime:desc}){
     id
     is_guest
     anonymous_check
     usersregister_userregister{
       id
       name
       surname
       fiscal_code
     }
     datetime
  }
}
`;

const QUERY_USER_SERVICES_USED=gql`
query userServicesUsed($userId:bigint!){
  clubmate_entrance_clubmatereservation(where:{user_id:{_eq:$userId}},order_by:{datetime:desc}){
    id
    datetime
    clubmateservice_clubmateservice{
      id
      name
    }
  }
}
`;

const QUERY_SERVICES=gql`
query GetServices{
  clubmate_clubmateservice_clubmateservice{
    id
    name
    visible_for_partner
  }
}
`;

const QUERY_PACKAGE=gql`
query GetPackage{
  clubmate_clubmatepackage_clubmatepackage{
    id
    name
  }
}
`;

const UPSERT_MOVEMENT_WALLET=gql`
mutation AddMovementWallet($input: MovementWalletMutationInput!){
  clubmate{
    upsertMovementwallet(input:$input){
      movementWallet{
        id
        quantity
      }
      errors{
        messages
      }
    }
  }
}
`;

export { UPSERT_USER, DELETE_USER,GET_USER,QUERY_MAX_REGISTRATION_NUMBER, QUERY_USER_PACKAGE_LIST, QUERY_PACKAGE_LIST,QUERY_USER_PACKAGE,UPSERT_USER_PACKAGE,GET_WALLET,DELETE_USER_PACKAGE,QUERY_SINGLE_USER_PACKAGE,QUERY_USER_ENTRANCE,QUERY_USER_SERVICES_USED,QUERY_SERVICES,QUERY_PACKAGE,UPSERT_MOVEMENT_WALLET};